export default __webpack_public_path__ + "static/media/maternity-icon.e9c2447e.svg";